import { render, staticRenderFns } from "./FileAttachment.vue?vue&type=template&id=208263f2&scoped=true"
import script from "./FileAttachment.vue?vue&type=script&lang=js"
export * from "./FileAttachment.vue?vue&type=script&lang=js"
import style0 from "./FileAttachment.vue?vue&type=style&index=0&id=208263f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208263f2",
  null
  
)

export default component.exports